// extracted by mini-css-extract-plugin
export default {"popUpWrap":"styles_popUpWrap__Y1c1o","popUp":"styles_popUp__C4tEE","popUpOpen":"styles_popUpOpen__ZK2iu"};